import { z } from "zod";

export const createSupplierNoteSchema = z.object({
    refId: z.string().min(1, "Required"),
    issueDate: z.coerce.date(),
    supplierId: z.string().min(1, "Required"),
    description: z.string().optional(),
    totalAmount: z.number().min(1, "Enter amount"),
    noteType: z.string().min(1, "Required")
  });